import { render } from "./TextTemplateButton.vue?vue&type=template&id=4164145e&scoped=true"
import script from "./TextTemplateButton.vue?vue&type=script&lang=js"
export * from "./TextTemplateButton.vue?vue&type=script&lang=js"

import exportComponent from "/Users/erik/IdeaProjects/reportx/client/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4164145e"]])

export default __exports__